import React, { useState } from "react"
import CarChart from "./car"
import CustomerChart from "./customer"
import UserChart from "./user"
import { Slider, Icon } from "antd-mobile"

import "./index.scss"
const Tabs = [
  { name: "车流量", key: "car", com: CarChart },
  { name: "客流量", key: "customer", com: CustomerChart },
  { name: "用户信息", key: "user", com: UserChart },
]
export default class HomeCharts extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cur: 0,
      collapse: true,
    }
  }
  changeTab = i => {
    this.setState({ cur: i })
  }
  togglePanel = () => {
    this.setState({ collapse: !this.state.collapse })
  }
  componentDidMount() {}
  render() {
    let { cur, collapse } = this.state
    return (
      <div
        className={
          "chart-panel home-chart-panel chart-" +
          Tabs[cur].key +
          (collapse ? "" : " expand")
        }
      >
        <Icon
          className="panel-switch"
          type={collapse ? "up" : "down"}
          onClick={this.togglePanel}
        />
        <div className="panel-inner">
          <div className="panel-tab">
            {Tabs.map((tab, i) => {
              return (
                <div
                  key={i}
                  className={i === cur ? "active" : ""}
                  onClick={() => {
                    this.changeTab(i)
                  }}
                >
                  {tab.name}
                </div>
              )
            })}
          </div>
          <div className="panel-con">
            {Tabs.map((tab, i) => {
              return (
                <div
                  key={i}
                  className={
                    "panel-con-" + tab.key + (i === cur ? " active" : "")
                  }
                >
                  {tab.name ? (
                    <div className="panel-con-title">{tab.name}</div>
                  ) : null}
                  <tab.com {...this.props} />
                  {i === 1 ? <MySlider {...this.props} /> : null}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

function MySlider({ onHourChange, hour, lastHour }) {
  var [h, setH] = useState(hour)
  if (lastHour < 1) {
    return null
  }
  return (
    <div className="my-slider">
      <Slider
        style={{ marginLeft: 10, marginRight: 30 }}
        defaultValue={hour}
        min={0}
        max={lastHour}
        onChange={v => setH(v)}
        onAfterChange={onHourChange}
        trackStyle={{
          backgroundColor: "#424FD7",
          height: "2px",
        }}
        railStyle={{
          backgroundColor: "#454C5F",
          height: "2px",
        }}
        handleStyle={{
          borderColor: "#424FD7",
          height: "14px",
          width: "14px",
          marginLeft: "-7px",
          marginTop: "-6px",
          backgroundColor: "#424FD7",
        }}
      >
        <span
          className="tick-hour"
          style={{ left: (h / lastHour) * 100 + "%" }}
        >
          {h + ":00"}
        </span>
      </Slider>
    </div>
  )
}
